import React, { useEffect, useState } from 'react';
import {
  ControlledTextField,
  ControlledTextFieldProps,
} from './ControlledTextField';
import { EntityWithIdAndDescription } from '../../types/baseEntities';

interface AsyncSelectProps extends ControlledTextFieldProps {
  loadOptions: () => Promise<EntityWithIdAndDescription[]> | undefined;
  autoSelect?: boolean;
}

export const AsyncSelect = ({ autoSelect = false, ...props}: AsyncSelectProps) => {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState<EntityWithIdAndDescription[]>([]);
  const [autoSelectValue, setAutoSelectValue] = useState<number>();

  const { loadOptions } = props;

  useEffect(() => {
    const request = loadOptions();

    if (request) {
      setLoading(true);

      request.then((options) => {

        if (autoSelect && options.length === 1) {
          const uniqueValue = options[0].id;

          // @ts-ignore
          props.control._formValues[props.name] = uniqueValue;
          setAutoSelectValue(uniqueValue);
        }

        setOptions(options);
        setLoading(false);
      });
    }
  }, [loadOptions]);

  return (
    <ControlledTextField
      {...props}
      select
      options={loading ? undefined : options}
      key={autoSelectValue}
      disabled={props.disabled || !!autoSelectValue}
    />
  );
};














